import Vue from 'vue'
import Vuex from 'vuex'
import * as firebase from "firebase/app";

// If you enabled Analytics in your project, add the Firebase SDK for Analytics
import "firebase/analytics";

// Add the Firebase products that you want to use
import "firebase/auth";
import "firebase/database"
import "firebase/storage"

Vue.use(Vuex)

var config = {
  getters: {
    tree: state => state.tree,
    flatCategories: state => state.flatCategories,
    categories: state => state.categories,
    progressStatus: state => state.progressStatus,
  },
  state: {
    tree: {},
    flatCategories: [],
    categories: [],
    progressStatus: {}
  },
  mutations: {
    setTree: (state, tree) => state.tree = tree,
    addStickers: (state, cat) => cat.stickers = [],
    setProgressStatus: (state, status) => state.progressStatus = status
  },
  actions: {
    updateTree({ state }) {
      firebase.database().ref(version).set(state.tree)

    }
  },
  modules: {
  }
};
var firebaseConfig = {
  apiKey: "AIzaSyAHBvRB1QrnC4jhy2LydBqtEQzxys4hia4",
  authDomain: "kan-stickers.firebaseapp.com",
  databaseURL: "https://kan-stickers.firebaseio.com",
  projectId: "kan-stickers",
  storageBucket: "kan-stickers.appspot.com",
  messagingSenderId: "182520373846",
  appId: "1:182520373846:web:0e1cb76123adc952de51f7",
  measurementId: "G-YVW2NNE4Q4"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();





const store = new Vuex.Store(config)

const version = new URLSearchParams(window.location.search).get("v") || "v3"

var server = false;
var edit = false;

firebase.database().ref(version).on('value', v => {
  server = true;
  store.commit("setTree", v.val())
}
);
store.watch((s, g) => g.tree, (n) => {

  if (!edit && !server) {
    setTimeout(() => {
      firebase.database().ref(version).set(n)
      edit = false
    }, 5000)
  }
  server = false
}, {
  deep: true
})

firebase.database().ref("status").on('value', v => {
  store.commit("setProgressStatus", v.val())
}
);

export default store;